export default "__VITE_ASSET__11b60b19__"